<template>
  <div class="container-video">
    <div class="row justify-content-center">
      <div class="col-md-8 col-12">
        <div class="video-clip">
          <video controls class="w-100" style="height: auto;">
            <source src="/especiales/factchecking-loreto/clips/clip_02.mp4" type="video/mp4" />
          </video>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "VideoClip02",
};
</script>

<style>
.video-clip {
  display: flex;  
  margin: 0 auto; /* Centra el video en su contenedor */
  padding: 15px; /* Añade un poco de espacio alrededor */
}
</style>